<template>
  <div class="channel-box">
    <div class="channel-label">Send from</div>
    <v-radio-group :value="value" @change="$emit('input', $event)" row hide-details class="channel-group">
      <v-radio label="Cash balance" value="cash"></v-radio>
      <v-radio label="Gift budget" value="gift"></v-radio>
    </v-radio-group>
    <p class="channel-hint">
      Gift budget available: <b>{{ giftBalance | money }}</b>.
      <span v-if="value === 'gift'">The recipient is credited the same way; the amount comes out of the gift budget and is booked as a company gift.</span>
    </p>
  </div>
</template>

<script>
/**
 * Channel picker for the company (Snap) charge center, accountant doc
 * 2026-10-03 item 1.9: "cash" sends from the center balance, "gift" from the
 * separate gift budget. Shown only when the logged-in center is a company
 * center (see mixins/centerGiftChannel.js).
 */
export default {
  name: "CenterGiftChannel",
  props: {
    value: { type: String, default: "cash" },
    giftBalance: { type: Number, default: 0 },
  },
};
</script>

<style scoped>
.channel-box {
  margin: 8px 0 4px;
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}

.channel-label {
  font-size: 13px;
  color: #546e7a;
}

.channel-group {
  margin-top: 0;
  padding-top: 4px;
}

.channel-hint {
  margin: 4px 0 0;
  font-size: 12px;
  color: #78909c;
}
</style>
